import rootReducer from "../../../../store";
import {
  RenderPage,
  editModal,
  openModal,
  resetFormState,
  setTableLoading,
  updateRendererFormState,
} from "../../../../slices/common/reducer";
import { showToast } from "../../../../common/Toaster/Toaster";
import {
  setDetailsData,
  setOrgId,
  setRolesData,
} from "../../../../slices/team/roles/rolesSlice";
import api from "../../../../Utils/interface";

export let createRole = async (entity, entityType, orgtype, organizationid) => {
  const updatedEntity = {
    ...entity,
    entitytype: entityType,
    orgtype: orgtype,
    organizationid: organizationid,
  };
  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity));
  fd.append("entitytype", entityType);
  fd.append("orgtype", orgtype);

  await api
    .post(`/entity/create`, fd, {
    })
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(openModal(false));
      showToast("Role added successfully", "success");
    })
    .catch((error) => {
      showToast(error?.response?.data?.error_message, "error");
      // const roleName = entity.name;
      // showToast(
      //   `Unable to create role as ${roleName} already exists.`,
      //   "error"
      // );
    });
};

export const getRolesData = (entity_id, entity_type) => {
  let fd = new FormData();

  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      if (res) {
        rootReducer.dispatch(setDetailsData(res.data));
        rootReducer.dispatch(updateRendererFormState(res.data));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export let updateRole = async (entity, entityid, entityType, navigator) => {
  const excludedKeys = ["created_date", "modified_date"];

  // Create a new object excluding the specified keys
  const updatedEntity = Object.fromEntries(
    Object.entries(entity).filter(([key]) => !excludedKeys.includes(key))
  );

  // Add the entityid and entitytype to the updatedEntity
  updatedEntity.entityid = entityid;
  updatedEntity.entitytype = entityType;

  let fd = new FormData();
  fd.append("entity", JSON.stringify(updatedEntity)); // Append the filtered entity
  fd.append("entityid", entityid);
  fd.append("entitytype", entityType);

  await api
    .post(`/entity/update`, fd)
    .then((response) => {
      rootReducer.dispatch(RenderPage());
      rootReducer.dispatch(resetFormState());
      rootReducer.dispatch(editModal(false));
      rootReducer.dispatch(openModal(false));
      navigator("/team/role");
      showToast("Role Updated Successfully!", "success");
    })
    .catch((error) => {
      showToast(error?.response?.data?.error_message, "error");
    });
};


export const getRoleList = (organizationId, entityType) => {
  const setLoadingTimeout = setTimeout(() => {
    rootReducer.dispatch(setTableLoading(true));
  }, 300);
  api
    .get(`/agsp/getAllAccessibleRoles`, {
      params: {
        organizationId: organizationId,
        entityType: entityType,
      },
    })
    .then((res) => {
      rootReducer.dispatch(setRolesData(res.data));
      clearTimeout(setLoadingTimeout);
    })
    .catch((err) => {
      console.log(err);
      clearTimeout(setLoadingTimeout);
      rootReducer.dispatch(setTableLoading(false));
    });
};
